var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 8.70303L4.61792 12.0851C4.52562 12.1774 4.4096 12.2246 4.26986 12.2267C4.13012 12.2289 4.01197 12.1817 3.91539 12.0851C3.8188 11.9885 3.77051 11.8714 3.77051 11.7338C3.77051 11.5962 3.8188 11.4791 3.91539 11.3825L7.29744 8.00048L3.91539 4.61841C3.82308 4.52611 3.77586 4.41009 3.77372 4.27035C3.77158 4.13061 3.8188 4.01246 3.91539 3.91588C4.01197 3.81929 4.12906 3.771 4.26666 3.771C4.40426 3.771 4.52135 3.81929 4.61792 3.91588L7.99999 7.29793L11.3821 3.91588C11.4744 3.82357 11.5904 3.77635 11.7301 3.77421C11.8699 3.77207 11.988 3.81929 12.0846 3.91588C12.1812 4.01246 12.2295 4.12955 12.2295 4.26715C12.2295 4.40475 12.1812 4.52183 12.0846 4.61841L8.70254 8.00048L12.0846 11.3825C12.1769 11.4748 12.2241 11.5909 12.2263 11.7306C12.2284 11.8703 12.1812 11.9885 12.0846 12.0851C11.988 12.1817 11.8709 12.23 11.7333 12.23C11.5957 12.23 11.4786 12.1817 11.3821 12.0851L7.99999 8.70303Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.78ca4f31b1d77dcd8a649f98e9dc17ab.svg";
export { ForwardRef as ReactComponent };